import getNextBusinessDay from './getNextBusinessDay';

export default function getOfferingFallBack() {
    return {
        myAlertIndicator: false,
        promise: {
            skuDeliveryOptions: [
                {
                    deliveryOptions: {
                        shipToHome: {
                            serviceLevels: [
                                {
                                    deliveryDateStart: new Date(),
                                    deliveryDateEnd: getNextBusinessDay(7),
                                },
                            ],
                            availabilityStatus: 'AH',
                            shipDate: getNextBusinessDay(7),
                        },
                    },
                },
            ],
        },
        isFallBack: true,
    };
}
